<template>
  <div fluid>
    <p class="text-h6 pl-2">직원조회</p>
    <v-card class="pb-5 elevation-0">
      <v-container fluid>
        <v-data-table
          :headers="headers"
          :items="detailData"
          hide-default-header
          hide-default-footer
          class="pa-5 elevation-0"
        >
          <template v-slot:item="props">
            <tr v-for="(header, i) in props.headers" :key="i">
              <th class="text-subtitle-2 emp-tbl-th">{{ header.text }}</th>
              <td class="text-body-2">
                {{ props.item[header.value] }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="btn_wrap text-center mt-15">
          <v-btn
            @click="editClick"
            :edit-form-modal="true"
            class="mr-3"
            outlined
            color="yellow darken-3"
            >수정</v-btn
          >
          <v-btn
            @click="clickEmpList"
            depressed
            class="mr-3 white--text"
            color="yellow darken-3"
            >목록</v-btn
          >
        </div>
        <EmpEditForm v-if="editForm" @close="editForm = false"></EmpEditForm>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { empDetail } from "@/api/employee.js";
import EmpEditForm from "@/components/employee/EmpEditForm";

export default {
  data() {
    return {
      headers: [
        {
          text: "부서",
          align: "center",
          sortable: false,
          width: "200",
          value: "deptNm",
        },
        {
          text: "직급",
          align: "center",
          sortable: false,
          width: "100",
          value: "empRank",
        },
        {
          text: "이름",
          align: "center",
          sortable: false,
          width: "100",
          value: "empNm",
        },
        {
          text: "생년월일",
          align: "center",
          sortable: false,
          value: "birthDt",
        },
        { text: "이메일", align: "center", sortable: false, value: "email" },
        {
          text: "휴대폰번호",
          width: "150",
          align: "center",
          sortable: false,
          value: "mobile",
        },
        {
          text: "내선번호",
          width: "80",
          align: "center",
          sortable: false,
          value: "extensionTel",
        },
        {
          text: "비상연락망",
          width: "150",
          align: "center",
          sortable: false,
          value: "emergencyTel",
        },
        {
          text: "주소",
          width: "500",
          align: "center",
          sortable: false,
          value: "address",
        },
        {
          text: "휴가일\n(잔여휴가일/총휴가일)",
          width: "150",
          sortable: false,
          align: "center",
          value: "leaveDay",
        },
        {
          text: "휴가시간\n(잔여휴가시간/총휴가시간)",
          width: "200",
          sortable: false,
          align: "center",
          value: "leaveTime",
        },
        {
          text: "입사일",
          width: "100",
          align: "center",
          sortable: false,
          value: "empJoinDt",
        },
      ],
      editForm: false,
      detailData: [],
    };
  },
  props: ["editFormModal"],
  async created() {
    try {
      const empNo = this.$route.params.id;
      let { data } = await empDetail(empNo);

      const newData = [data.form].map(v => ({
        ...v,
        address: `(${v.zipcd}) ${v.addr} ${v.dtlAddr}`,
        leaveDay: `${v.restLeaveDay} / ${v.totLeaveDay}`,
        leaveTime: `${v.restLeaveTime} / ${v.totLeaveTime}`,
      }));

      this.detailData = newData;
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    clickEmpList() {
      this.$router.push("/employee");
    },
    editClick() {
      this.editForm = !this.editForm;
    },
  },
  components: {
    EmpEditForm,
  },
};
</script>

<style scoped lang="scss">
.v-card {
  white-space: pre-line;
}
.emp-tbl-th {
  width: 230px;
}
</style>
